import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from '../services/toastService/toastr.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'toastr',
  templateUrl: './toastr.component.html',
  styleUrls: ['./toastr.component.css']
})
export class ToastrComponent implements OnInit,OnDestroy {
  toastr: { message: string, type: string }[] = [];
  private toastSubscription!: Subscription;
  constructor(private toastrService: ToastrService) { }

  ngOnInit(): void {
    console.log("ngoninit called")
    this.toastSubscription = this.toastrService.toastState$.subscribe(toast => {
      this.toastr.push(toast);
      console.log(this.toastr,"this is toast")
      setTimeout(() => {
        this.toastr.shift();
      }, 3000);
    });
  }
  
  ngOnDestroy(): void {
    if (this.toastSubscription) {
      this.toastSubscription.unsubscribe();
    }
  }
}
